import { Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import theme from '@/theme/default.ts';
import AppRoutes from '@/AppRoutes.tsx';
import { AppProvider } from '@/context/app';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModuleFallBack from '@/components/ModuleFallBack';
import InitialDataLoader from '@/components/InitialDataLoader';
import WsNotificationConnector from '@/components/WsNotificationConnector';
// import RegisterLastActivity from '@/components/RegisterLastActivity';
import CheckNewAppVersion from './components/CheckNewAppVersion';
import { IdleProvider } from './context/IdleProvider.tsx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './style.css';
import { PasswordModalProvider } from './context/PasswordEditContext.tsx';

const DEFAULT_STALE_TIME = 1000 * 60;
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: DEFAULT_STALE_TIME } } });

function App() {
    return (
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <Suspense fallback={<ModuleFallBack />}>
                    <AppProvider>
                        <CheckNewAppVersion />
                        <InitialDataLoader />
                        {/* <RegisterLastActivity /> */}
                        <WsNotificationConnector />
                        {/* Incluye la logica de RegisterLastActivity */}
                        <IdleProvider>
                            <PasswordModalProvider>
                                <AppRoutes />
                            </PasswordModalProvider>
                        </IdleProvider>
                        <ToastContainer theme={'colored'} />
                    </AppProvider>
                </Suspense>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </ThemeProvider>
    );
}

export default App;
